import React, { useEffect, useState } from 'react'
import { Letter } from '../components/Letter'
import { HStack, Square, Grid, GridItem, Button, Icon } from '@chakra-ui/react'
import { IoChevronUp } from 'react-icons/io5'
import { KeyboardIcon } from '@/components/icons/KeyboardIcon'
import { StickyContainer } from '../components/StickyContainer'

type ContainerProps = {
  availableLetters: string[]
  selectedLetter: string
  setSelectedLetter: (val: string) => void
}

export const LetterContainer = ({
  availableLetters,
  selectedLetter,
  setSelectedLetter,
}: ContainerProps) => {
  const [isExpand, setIsExpand] = useState(false)
  const keys = availableLetters.map((x) => x)
  keys.push('collapse')

  useEffect(() => {
    setIsExpand(false)
  }, [selectedLetter])

  return (
    <StickyContainer>
      {!isExpand ? (
        <HStack spacing={'5px'}>
          {[
            '#',
            availableLetters[1],
            availableLetters[2],
            '...',
            availableLetters[availableLetters.length - 1],
          ].map((letter, idx) => (
            <Letter
              key={letter}
              letter={letter}
              selectedLetter={selectedLetter}
              setSelectedLetter={setSelectedLetter}
            />
          ))}
          <Square
            border={'1.5px solid #EAEEF4'}
            borderRadius={'2px'}
            size={'52px'}
            onClick={() => setIsExpand(true)}
            background={'#FFFFFF'}
          >
            <KeyboardIcon color={'gray.350'} />
          </Square>
        </HStack>
      ) : (
        <Grid
          templateRows={['repeat(5, 1fr)', null, 'repeat(3, 1fr)']}
          templateColumns={['repeat(6,1fr)', null, 'repeat(12, 1fr)']}
          gap={'3px'}
        >
          {keys.map((key, i, arrayRef) =>
            i !== arrayRef.length - 1 ? (
              <GridItem key={key} colSpan={1}>
                <Letter
                  letter={key}
                  selectedLetter={selectedLetter}
                  setSelectedLetter={setSelectedLetter}
                />
              </GridItem>
            ) : (
              <GridItem colSpan={3}>
                <Button
                  w={'100%'}
                  h={'100%'}
                  background={'#FFFFFF'}
                  border={'1.5px solid #EAEEF4'}
                  borderRadius={'2px'}
                  onClick={() => setIsExpand(false)}
                >
                  <Icon as={IoChevronUp} boxSize={'36px'} ml={'auto'} />
                </Button>
              </GridItem>
            )
          )}
        </Grid>
      )}
    </StickyContainer>
  )
}
